import React from 'react';
import { Box, Typography } from '@mui/material';
import Container from '@mui/material/Container';

const FaqPage = () => (
    <Container maxWidth="sm" sx={{ textAlign: 'center', paddingTop: 6 }}>
    <Box p={4}>
        <Box sx={{ mt: 6, textAlign: 'center' }}>
            <Typography variant="h5" gutterBottom>
                Frequently Asked Questions (FAQ)
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
                Is this a real IBAN?
            </Typography>
            <Typography variant="body2" paragraph>
                No — the IBANs generated are fake but structurally valid. They are safe for testing but not usable for actual banking transactions.
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
                Can I use this IBAN to receive payments?
            </Typography>
            <Typography variant="body2" paragraph>
                Absolutely not. These IBANs are randomly generated and not linked to any real accounts or financial institutions.
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
                Who is this tool for?
            </Typography>
            <Typography variant="body2" paragraph>
                This tool is intended for developers, QA testers, and fintech professionals who need dummy IBANs for automated tests or demo environments.
            </Typography>
        </Box>
    </Box>
    </Container>
);

export default FaqPage;
